module.exports = __webpack_public_path__ + "static/media/44550234_2199894000085779_1264654370142683136_o-thumb.8f70c627.jpg";